<template>
  <div class="single-ellipsis-tooltip">
    <div class="contentPlaceholderTemp">{{content}}</div>
    <div class="tooltipBoxWrap">
      <el-tooltip :effect="effect" :placement="placement" :disabled="!showToolTip">
        <div ref="containRef" class="ellipsis-single">{{content}}</div>
        <template #content>
          <slot name="content">
            <div style="max-width: 200px;">{{content}}</div>
          </slot>
        </template>
      </el-tooltip>
      <div class="contentWidthTempWrap">
        <div ref="contentWidthRef" class="contentWidthTemp">{{content}}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {defineProps, withDefaults} from 'vue';

  interface Props {
    content: string;
    effect?: 'dark' | 'light';
    placement?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    effect: 'dark',
    placement: 'top',
  });

  const contentWidthRef = ref();
  const containRef = ref();

  const comData = reactive({
    containWidth: 0,
    textWidth: 0,
  });

  const showToolTip = computed(() => {
    return comData.textWidth > comData.containWidth;
  });

  function updateComData() {
    try {
      const a = containRef.value.getBoundingClientRect();
      const b = contentWidthRef.value.getBoundingClientRect();
      comData.containWidth = a.width;
      comData.textWidth = b.width;
    } catch (e) {
      console.error(e);
    }
  }

  watch(() => {
    return props.content;
  }, async () => {
    await nextTick();
    updateComData();
  });

  onMounted(() => {
    updateComData();
  });


</script>

<style scoped lang="scss">
  .single-ellipsis-tooltip {
    display: flex;
    position: relative;
    .contentPlaceholderTemp {
      white-space: nowrap;
      overflow: hidden;
      opacity: 0;
      color: transparent;
      visibility: hidden;
    }
    .tooltipBoxWrap {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      overflow: hidden;
      .contentWidthTempWrap {
        position: absolute;
        z-index: -99;
        left: 0;
        top: 0;
        width: 5000px;
        display: flex;
        .contentWidthTemp {
          opacity: 0;
          color: transparent;
          visibility: hidden;
        }
      }
    }

  }
</style>
